import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DividendReInvestFacade } from '@zero/shared/feature-dividend-re-invest/base';
import { ButtonComponent, CheckboxComponent, ModalComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'shared-dividend-received-modal',
  imports: [ModalComponent, TranslocoPipe, ButtonComponent, AsyncPipe, CheckboxComponent],
  templateUrl: './dividend-received-modal.component.html',
})
export class DividendReceivedModalComponent {
  public readonly modal = inject(NgbActiveModal);
  public readonly facade = inject(DividendReInvestFacade);

  public isCheckboxChecked = false;

  public activate = (value: number): void => {
    this.facade.activate(value);
    this.modal.dismiss();
  };

  public decline = (): void => {
    this.facade.decline();
    this.modal.dismiss();
  };
}
